import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MntchofService {
    private cntr: string ='AdmnMonitoreo/'
    private apiUrl: string =environment.SUrlgApi;
    private getColab: string = '';
    private getHstColab: string = '';
    private postEst: string = '';
    private putEst: string = '';
    private getrptEstChof: string = '';
    constructor(private _http: HttpClient) {
      this.getColab = this.apiUrl + this.cntr + "ConsultaColaboradores";
      this.getHstColab = this.apiUrl + this.cntr + 'ConsultaHistoricoEstatus';
      this.postEst=this.apiUrl + this.cntr +'AgregaEstatus';
      this.putEst = this.apiUrl + this.cntr + 'ModEstatus';
      this.getrptEstChof = this.apiUrl + this.cntr + 'GetRptEstColab';
    }

    getChof(id_ciudad_hm:number, clv_activo: number,cod_usuario:string): Observable<any[]> {
        const valores = {
          params: new HttpParams().
            set('id_ciudad_hm', id_ciudad_hm).
            set('clv_activo', clv_activo).
            set('cod_usuario', cod_usuario)
        };
        return this._http.get<any[]>(this.getColab, valores).pipe(retry(1), catchError(this.handleError));
    }
    getHstEstatus(cod_chofer:number): Observable<any[]> {
        const valores = {
          params: new HttpParams().
            set('cod_chofer',cod_chofer)
        };
        return this._http.get<any[]>(this.getHstColab, valores).pipe(retry(1), catchError(this.handleError));
    }

    PostEstChof(data:any):Observable<any>{
        const headers = { 'content-type': 'application/json'}
        const body = JSON.stringify(data);
        return this._http.post<any>(this.postEst,body,{headers})
        .pipe(retry(1), catchError(this.handleError));
    }

    PutEstChof(data:any):Observable<any>{
        const headers = { 'content-type': 'application/json'}
        const body = JSON.stringify(data);
        return this._http.put<any>(this.putEst,body,{headers})
        .pipe(retry(1), catchError(this.handleError));
    }

    // AuthBonoContratacion(data:any):Observable<any>{
    //     const headers = { 'content-type': 'application/json'}
    //     return this._http.put<any>(this.apiUrlAuthBonoContratacion,data,{headers})
    //     .pipe(retry(1), catchError(this.handleError));
    // }

    // rptbono(num_anio: number, id_semana: number,id_ciudad_principalrpt : number): Observable<any[]> {
    //     const valores = {
    //         params: new HttpParams()
    //         .set('num_anio', num_anio)
    //         .set('id_semana', id_semana)
    //         .set('id_ciudad_principal', id_ciudad_principalrpt )
    //         }

    //     return this._http
    //         .get<any[]>(this.apiUrlrpt,valores).pipe(retry(1), catchError(this.handleError));
    // }
    rptEstChof(id_ciudad_hm:number,fec_inicio:string,fec_fin:string): Observable<any> {
        const valores = {
          params: new HttpParams().
            set('id_ciudad_hm', id_ciudad_hm).
            set('fec_inicio', fec_inicio).
            set('fec_fin', fec_fin)
        };
        return this._http
            .get<any>(this.getrptEstChof,valores).pipe(retry(1), catchError(this.handleError));
    }

    handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
    }
}

